import { DivFlexColumn, DivGridGap } from '@pages/CommonStyle/commonDiv.style';
import React, { PropsWithChildren } from 'react';
import { RecommendLayout, RecommendMore } from './Recommend.style';
import { RecommendProductGrid, RecommendProductImg, RecommendProductMore, RecommendProductSection, RecommendProductTextBox } from './RecommendProducts.style';
import { StyledHeading, StyledLabel, StyledParagraph } from '@components/Text';
import { Trans } from 'react-i18next';
import { ParagraphColor, Spacing } from '@pages/CommonStyle/common.style';

interface ModalDefaultType {
  products: any;
}

const RecommendProducts = ({ products }: PropsWithChildren<ModalDefaultType>) => {
  return (
    <>
      <RecommendProductGrid>
        {products.map((product) => (
          <>
            <RecommendProductSection>
              <DivFlexColumn>
                <RecommendProductImg src={product.data.img} />
                <RecommendProductTextBox>
                  <StyledHeading size="xsmall">
                    <Trans i18nKey={product.data.title} />
                  </StyledHeading>
                  <Spacing pixel="8" />
                  <ParagraphColor size="medium" color="#818181">
                    <Trans i18nKey={product.data.desc} />
                  </ParagraphColor>
                  <Spacing pixel="24" />
                  <RecommendProductMore>
                    <StyledLabel size="medium">
                      <Trans i18nKey={`Learn More`} />
                    </StyledLabel>
                  </RecommendProductMore>
                  <Spacing pixel="52" />
                </RecommendProductTextBox>
              </DivFlexColumn>
            </RecommendProductSection>
          </>
        ))}
      </RecommendProductGrid>
    </>
  );
};

export default RecommendProducts;
